<template>
  <section class="error-page">
    <div v-if="$route.query.reason === 'open-from-admin'">
      <p>Open Airfields from the Apps section of your Shopify admin.</p>
    </div>
    <div v-else>
      <p>Something went wrong.</p>
      <p>Please try again.</p>
    </div>
  </section>
</template>
<script>
  export default {
  }
</script>
<style lang="scss">
  .error-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.3;
  }
</style>


// WEBPACK FOOTER //
// src/pages/error.vue